import React from 'react';

function RefundComp() {
    const refundPolicyData = [
        {
          heading: "General Statement",
          paragraph:
            "All auction sales are final. Due to the nature of unique and collectible items, returns and refunds are not offered except under rare and specific circumstances.",
        },
        {
          heading: "Acceptable Grounds for Refunds",
          points: [
            "Proven case of item misrepresentation (e.g., falsely attributed artist, incorrect condition grade)",
            "Item damaged in transit due to improper packaging by our team",
            "Duplicate payment errors",
          ],
        },
        {
          heading: "Refund Request Procedure",
          points: [
            "Contact us at refunds@anachronisticauction.com within 10 calendar days of receiving the item",
            "Provide supporting documentation (e.g., photos, third-party appraisal if applicable)",
            "Our team will review and respond within 7 business days",
          ],
        },
        {
          heading: "Exclusions",
          points: [
            "Disputes over market value",
            "Buyer remorse",
            "Delays caused by customs or third-party shipping providers",
          ],
        },
        {
          heading: "Refund Processing",
          paragraph:
            "Approved refunds are issued via the original payment method within 10–14 business days after approval.",
        },
      ];
      
  return (
  
     <section className="sec_pd mb-5 mt-5">
       <h3 className="text-black mb-4">Refund Policy</h3>
     {refundPolicyData.map((section, idx) => (
       <div key={idx} className="mb-4">
         <p className="text-black fw-bold mt-4">{idx + 1}. {section.heading}</p>
         
         {section.paragraph && (
           <p className="text-muted">{section.paragraph}</p>
         )}

         {section.points && (
           <ul className="text-muted list-disc list-inside ml-4 mt-2">
             {section.points.map((point, i) => (
               <li key={i}>{point}</li>
             ))}
           </ul>
         )}
       </div>
     ))}
   </section>
  );
}

export default RefundComp;
